import styled from 'styled-components';
import { H4 } from '../../../../../../assets/elements/Typography/Headings';

export const H4Styled = styled(H4)`
  margin-bottom: 32px;
`;
